import { render } from "./GenerateFulfillments.vue?vue&type=template&id=2ad196e5"
import script from "./GenerateFulfillments.vue?vue&type=script&lang=js"
export * from "./GenerateFulfillments.vue?vue&type=script&lang=js"

import exportComponent from "/home/websites/repositories/macgear-scanner/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__